import {CommonData} from '@udemy-v2/common-data';
import {ShareableObject} from './types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const isMarketplaceShareEnabled = (shareableObject: ShareableObject) => {
    // TODO: Add logic to check if brand is allowed (not found in common data)
    // const brand = commonData.brand;
    return (
        // TODO: Add logic to check if shareableObject is private and if brand has an organization and if external sources are enabled
        // !shareableObject.is_private && !brand.has_organization && brand.is_external_sources_enabled
        true
    );
};

export const socialNetworks = (commonData: CommonData, isMobile: boolean) => {
    const isUserLoggedIn = 'user' in commonData;
    return [
        'clipboard',
        'twitter',
        ...(isMobile ? ['whatsapp'] : []),
        isUserLoggedIn ? 'mail_ref' : 'mailto',
    ];
};
